import React, { useRef } from 'react';
import {
    ActType,
    IMultiCapabilityTemplateInfo,
    ITemplateComponentProps,
    PanelType,
    VIEW_MODE,
} from '../../../interface/multiCapabilityTemplate';
import { Button } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { TemplateInfo } from '../../../components/templateInfo';
import ListBlankPC from '../../../../ListBlank/ListBlankPC';
const BodyContent = (props: ITemplateComponentProps) => {
    const { templateInfo, editorConfig, onCommunication } = props;
    const templateRef = useRef(null);
    const renderHeardContent = () => {
        const isShowHeard = editorConfig?.isShowPreview || !!editorConfig?.title;
        if (!isShowHeard) {
            return null;
        }
        return <div className="capability-flex-col capability-space-between">{editorConfig?.title}</div>;
    };
    const onDataChange = (data: IMultiCapabilityTemplateInfo) => {
        console.log(' onDataChange data = ', data);
    };
    const renderContent = () => {
        return (
            <div className="template-info-editor-zone small-rows">
                {templateInfo ? (
                    <TemplateInfo
                        isValid={false}
                        tmpRef={templateRef}
                        info={templateInfo}
                        mode={VIEW_MODE.VIEW}
                        onChange={onDataChange}
                    />
                ) : (
                    <ListBlankPC type={2} className="template-empty-info" title={lang('暂无评价标准')} />
                )}
            </div>
        );
    };
    const onSubmitClick = () => {
        onCommunication(ActType.PANEL_CANCEL, {
            info: {
                panelType: PanelType.EDIT,
            },
        });
    };
    return (
        <div className="template-info-detail">
            {renderHeardContent()}
            {renderContent()}
            <div className="footer-list capability-flex-col fix-right">
                <Button type="primary" className="btn-split" onClick={onSubmitClick}>
                    {lang('关闭')}
                </Button>
            </div>
        </div>
    );
};

export const templatePreview = {
    BodyContent,
};
